import { render, staticRenderFns } from "./ObjectivesOverviewDialog.vue?vue&type=template&id=fa453f42&scoped=true&"
import script from "./ObjectivesOverviewDialog.vue?vue&type=script&lang=js&"
export * from "./ObjectivesOverviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./ObjectivesOverviewDialog.vue?vue&type=style&index=0&id=fa453f42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa453f42",
  null
  
)

export default component.exports